module.exports = __webpack_public_path__ + "static/media/cd.e36ff267.svg";